import React, { useRef, useState } from "react";
import axios from "axios";
import ImageUploader from "../../misc/ImageUploader";
import Save from "../../../../../icons/save";
import Swal from "sweetalert2";

interface Props {
  foto: string;
  nombre: string;
  apellido: string;
  email: string;
  pais: string;
  canton: string;
  distrito: string;
  barrio: string;
  direccion: string;
}

const ProfileForm = ({
  nombre,
  apellido,
  email,
  pais,
  canton,
  distrito,
  barrio,
  direccion,
}: Props) => {
  const [selectedFile, setSelectedFile] = useState<File>();
  const nombreDataRef = useRef<HTMLInputElement>(null);
  const apellidoDataRef = useRef<HTMLInputElement>(null);

  const [usuario, setUsuario] = useState({
    nombre: undefined,
    apellido: undefined,
    pais: undefined,
    canton: undefined,
    distrito: undefined,
    barrio: undefined,
    direccion: undefined,
  });

  const updateProfile = async () => {
    try {
      Swal.fire({
        title: "Procesando...",
        text: "No cierre esta ventana.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      let data;
      const nameData = nombreDataRef.current?.value ?? "";
      const apellidoData = apellidoDataRef.current?.value ?? "";
      if (selectedFile !== undefined) {
        data = {
          nombre: usuario.nombre,
          apellido: usuario.apellido,
          pais: usuario.pais,
          canton: usuario.canton,
          distrito: usuario.distrito,
          barrio: usuario.barrio,
          direccion: usuario.direccion,
          foto: `usuarios/${nameData}-${apellidoData}-${selectedFile?.name}`,
        };
      } else {
        data = {
          nombre: usuario.nombre,
          apellido: usuario.apellido,
          pais: usuario.pais,
          canton: usuario.canton,
          distrito: usuario.distrito,
          barrio: usuario.barrio,
          direccion: usuario.direccion,
        };
      }

      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/usuarios/${sessionStorage.getItem(
          "user_id"
        )}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (selectedFile !== undefined) {
        try {
          const fileKey = `usuarios/${nameData}-${apellidoData}-${selectedFile.name}`;
          const { data: uploadData } = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/s3/upload-url`,
            { key: fileKey },
            { headers: { "auth-token": sessionStorage.getItem("token") } }
          );
          await axios.put(uploadData.url, selectedFile, { headers: { "Content-Type": selectedFile.type } });
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
      Swal.fire({
        title: "¡Perfil actualizado!",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "¡Error!",
        text: "Ha ocurrido un error, por favor intente de nuevo.",
        icon: "error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setUsuario({ ...usuario, [name]: value });
  };

  return (
    <div className="overflow-x-scroll pb-4">
      <form
        action=""
        className="w-full flex flex-col gap-2 max-w-lg m-auto"
        onSubmit={(e) => {
          e.preventDefault();
          updateProfile();
        }}
      >
        <button>
          <Save size={45} />
        </button>

        <ImageUploader setSelectedFile={setSelectedFile} inputId="Profile" />

        <div className="block">
          <label htmlFor="" className="">
            Nombre
          </label>
          <input
            type="text"
            ref={nombreDataRef}
            id="nombre"
            name="nombre"
            defaultValue={nombre}
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
        <div className="block">
          <label htmlFor="" className="">
            Apellido
          </label>
          <input
            ref={apellidoDataRef}
            type="text"
            id="apellido"
            name="apellido"
            defaultValue={apellido}
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
        <div className="block">
          <label htmlFor="" className="">
            Correo Electronico
          </label>
          <input
            readOnly={true}
            type="text"
            defaultValue={email}
            id="email"
            name="email"
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
        <>Direccion</>
        <div className="block">
          <label htmlFor="" className="">
            Pais
          </label>
          <input
            type="text"
            defaultValue={pais}
            id="pais"
            name="pais"
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
        <div className="block">
          <label htmlFor="" className="">
            Canton
          </label>
          <input
            type="text"
            defaultValue={canton}
            id="canton"
            name="canton"
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
        <div className="block">
          <label htmlFor="" className="">
            Distrito
          </label>
          <input
            type="text"
            defaultValue={distrito}
            id="distrito"
            name="distrito"
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
        <div className="block">
          <label htmlFor="" className="">
            Barrio
          </label>
          <input
            type="text"
            defaultValue={barrio}
            id="barrio"
            name="barrio"
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
        <div className="block">
          <label htmlFor="" className="">
            Direccion
          </label>
          <input
            type="text"
            defaultValue={direccion}
            id="direccion"
            name="direccion"
            onChange={handleInputChange}
            className="main-input"
          />
        </div>
      </form>
    </div>
  );
};

export default ProfileForm;
